import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = 'https://pyenbriacaivrnkwitqu.supabase.co';
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InB5ZW5icmlhY2FpdnJua3dpdHF1Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzcyNjExNjAsImV4cCI6MjA5MjgzNzE2MH0.VJsQRGFdiC4ahPDA9vsfgc13MKrEiPZHSdCdlysYaPk';

const storageClient = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);

export async function uploadPhoto(file, folder = 'tagouts') {
  try {
    const imageCompression = (await import('browser-image-compression')).default;
    const compressed = await imageCompression(file, {
      maxSizeMB: 0.5,
      maxWidthOrHeight: 1920,
      useWebWorker: true,
    });

    const ext = file.name.split('.').pop() || 'jpg';
    const filename = `${folder}/${Date.now()}-${Math.random().toString(36).substring(2)}.${ext}`;

    const { data, error } = await storageClient.storage
      .from('tool-assets')
      .upload(filename, compressed, {
        cacheControl: '3600',
        upsert: false,
        contentType: file.type || 'image/jpeg',
      });

    if (error) throw error;
    return { path: data.path, error: null };
  } catch (err) {
    return { path: null, error: err.message };
  }
}

export function getPhotoUrl(path) {
  if (!path) return null;
  return `${SUPABASE_URL}/storage/v1/object/public/tool-assets/${path}`;
}